import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.RoutePrefix
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    RoutePrefix.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { pl.krzyssko.portfoliowebsite.pages.HomePage() }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("page-content",
                pl.krzyssko.portfoliowebsite.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("footer",
                pl.krzyssko.portfoliowebsite.components.sections.FooterStyle)
        ctx.theme.registerStyle("hero", pl.krzyssko.portfoliowebsite.components.sections.HeroStyle)
        ctx.theme.registerStyle("hero-title",
                pl.krzyssko.portfoliowebsite.components.sections.HeroTitleStyle)
        ctx.theme.registerStyle("nav-header",
                pl.krzyssko.portfoliowebsite.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("headline-text",
                pl.krzyssko.portfoliowebsite.style.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text",
                pl.krzyssko.portfoliowebsite.style.SubheadlineTextStyle)
        ctx.theme.registerVariant("-circle", pl.krzyssko.portfoliowebsite.style.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored",
                pl.krzyssko.portfoliowebsite.style.UncoloredButtonVariant
        )
        ctx.theme.registerVariant("-primary",
                pl.krzyssko.portfoliowebsite.style.PrimaryButtonVariant
        )
        ctx.theme.registerKeyframes("side-menu-slide-in",
                pl.krzyssko.portfoliowebsite.components.sections.SideMenuSlideInAnim)
        pl.krzyssko.portfoliowebsite.initColorMode(ctx)
        pl.krzyssko.portfoliowebsite.style.initSiteStyles(ctx)
        pl.krzyssko.portfoliowebsite.style.initTheme(ctx)
    }

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    router.navigateTo(window.location.href.removePrefix(window.location.origin),
            UpdateHistoryMode.REPLACE)

    val root = document.getElementById("root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    AppGlobals.initialize(mapOf("title" to "PortfolioWebsite"))
    renderComposable(rootElementId = "root") {
        pl.krzyssko.portfoliowebsite.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
